import React from 'react'
import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

export interface ImsiCardProps {
  imsiTextColor: string
  currentImsi: string
  expectedImsi: string
}
export default function ImsiCard({
  imsiTextColor,
  currentImsi,
  expectedImsi
}: ImsiCardProps) {
  return (
    <>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '34px',
          p: '40px',
          maxWidth: '215px'
        }}
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{
            fontSize: '24px',
            fontWeight: '700px',
            m: 0
          }}
          text={'   IMSI Profile'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: '10px'
          }}
        >
          The IMSI must be set to one of these three: 7, 25 or 26, depending on
          which country the customer is roaming in
        </TextColorFontBody>

        <Stack
          flexDirection={'row'}
          sx={{ mt: '20px', justifyContent: 'space-between' }}
        >
          <Stack>
            <Typography
              sx={{ fontWeight: '400', color: '#7B8794' }}
              textAlign='left'
            >
              Latest
            </Typography>
            <Typography
              textAlign='left'
              sx={{
                color: imsiTextColor,
                fontWeight: '600',
                fontSize: '33px',
                pt: '15px'
              }}
            >
              {currentImsi}
            </Typography>
          </Stack>

          <Stack>
            <Typography
              sx={{ fontWeight: '400', color: '#7B8794' }}
              textAlign='left'
            >
              Expected
            </Typography>
            <Typography
              textAlign='left'
              sx={{
                color: imsiTextColor,
                fontWeight: '600',
                fontSize: '33px',
                pt: '15px'
              }}
            >
              {expectedImsi}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </>
  )
}
